import {errorText} from '../graphql/error-link';
import {Component, Inject, OnInit} from '@angular/core';
import {DIALOG_DATA, DialogRef} from '@angular/cdk/dialog';
import {File, Folder, Mutation} from '../types-repository';
import {Apollo, gql} from 'apollo-angular';
import {FILE_FOLDER_LIST_WITH_ARCHIVE} from '../queries-repository';
import {DatePipe} from '@angular/common';
import {DateComponent} from '../date/date.component';

@Component({
  selector: 'app-delete-dialog',
  templateUrl: './undelete-dialog.component.html',
  styleUrls: ['./undelete-dialog.component.scss'],
  imports: [DateComponent]
})
export class UndeleteDialogComponent implements OnInit {
  protected basedir: Folder;
  protected files: File[];
  deleting = false

  constructor(public dialogRef: DialogRef<string>,
              @Inject(DIALOG_DATA) public data: { basedir: Folder, files: File[] },
              private apollo: Apollo) {
    this.basedir = data.basedir;
    this.files = data.files;
  }

  ngOnInit(): void {
  }

  /** Why the last restore failed; shown above the buttons. */
  error: string | null = null;

  performUndelete() {
    this.deleting = true;
    this.error = null;
    const delete_mutations = this.files.map((f, index) => `undel${index}: undelete(input: {file_id: "${f.id}"}) {
  file {
     id
   }
}`).join('\n')

    const mut = gql`
      mutation BatchUndelete {
        ${delete_mutations}
      }`
    this.apollo.mutate<Mutation>({
      mutation: mut,
      refetchQueries: [{
        query: FILE_FOLDER_LIST_WITH_ARCHIVE,
        variables: {
          show_deleted: true,
          id: this.basedir.id
        },
      }]
    }).subscribe({
      next: () => {
        this.deleting = false;
        this.dialogRef.close();
      },
      error: err => {
        this.deleting = false;
        this.error = `Could not restore: ${errorText(err)}`;
      },
    })
  }
}
